// @ts-check
import {
  Flex,
  SkeletonBox,
  SkeletonText,
  TableBody,
  TableCell,
  TableRow,
} from '~/design-system';

export default function ImportsOverviewTableBodySkeleton() {
  return (
    <TableBody>
      <ImportInProgressRowSkeleton />
      <ImportInProgressRowSkeleton />
      <ImportInProgressRowSkeleton />
    </TableBody>
  );
}

/**
 * Used to render import in progress skeleton
 */
function ImportInProgressRowSkeleton() {
  return (
    <TableRow>
      <TableCell
        sx={{
          height: 65,
          width: 260,
        }}
      >
        <SkeletonText />
        <SkeletonText variant="smallest" />
      </TableCell>
      <TableCell sx={{ height: 65, width: 240 }}>
        <SkeletonText />
        <SkeletonText variant="smallest" />
      </TableCell>
      <TableCell sx={{ height: 65, width: 180 }}>
        <SkeletonText />
        <SkeletonText variant="smallest" />
      </TableCell>
      <TableCell sx={{ height: 65 }}>
        <Flex>
          <SkeletonBox
            height={22}
            width={48}
            sx={{ marginRight: 3, marginLeft: 2 }}
          />
          <SkeletonBox height={22} width={30} />
        </Flex>
      </TableCell>
    </TableRow>
  );
}
